import React, { useState } from 'react';

function BackupManager() {
  const [importing, setImporting] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [message, setMessage] = useState(null);
  const [clearExisting, setClearExisting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    setMessage(null);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('/api/backup/export', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Export fehlgeschlagen');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `kursplaner-backup-${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setMessage({ type: 'success', text: 'Backup erfolgreich heruntergeladen!' });
    } catch (err) {
      setMessage({ type: 'danger', text: 'Fehler beim Export: ' + err.message });
    } finally {
      setExporting(false);
    }
  };

  const handleImport = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImporting(true);
    setMessage(null);

    try {
      const text = await file.text();
      const backup = JSON.parse(text);

      if (!backup.data) {
        throw new Error('Ungültiges Backup-Format');
      }

      const token = localStorage.getItem('authToken');
      const response = await fetch('/api/backup/import', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          data: backup.data,
          options: { clearExisting }
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Import fehlgeschlagen');
      }

      const imported = result.data.imported;
      setMessage({
        type: 'success',
        text: `Import erfolgreich! Importiert: ${imported.courses} Kurse, ${imported.course_slots} Wochentermine, ${imported.visit_slots} Besichtigungstermine, ${imported.ki_lab_events} KI-Lab Events`
      });

      // Reset file input
      event.target.value = '';
    } catch (err) {
      setMessage({ type: 'danger', text: 'Fehler beim Import: ' + err.message });
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Backup & Wiederherstellung</h5>

        {message && (
          <div className={`alert alert-${message.type}`}>{message.text}</div>
        )}

        <div className="row">
          <div className="col-md-6">
            <div className="card bg-light mb-3">
              <div className="card-body">
                <h6 className="card-title">Daten exportieren</h6>
                <p className="card-text small text-muted">
                  Erstelle ein Backup aller Kurse, Module, Termine, Mitglieder und Buchungen als JSON-Datei.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={handleExport}
                  disabled={exporting}
                >
                  {exporting ? 'Exportiere...' : 'Backup herunterladen'}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card bg-light mb-3">
              <div className="card-body">
                <h6 className="card-title">Daten importieren</h6>
                <p className="card-text small text-muted">
                  Stelle Daten aus einer Backup-Datei wieder her.
                </p>

                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="clearExisting"
                    checked={clearExisting}
                    onChange={(e) => setClearExisting(e.target.checked)}
                  />
                  <label className="form-check-label small" htmlFor="clearExisting">
                    Bestehende Daten vorher loeschen
                  </label>
                </div>

                <input
                  type="file"
                  className="form-control"
                  accept=".json"
                  onChange={handleImport}
                  disabled={importing}
                />
                {importing && <small className="text-muted">Importiere...</small>}
              </div>
            </div>
          </div>
        </div>

        <div className="alert alert-info mt-3">
          <strong>Tipp:</strong> Erstelle regelmaessig Backups, besonders vor groesseren Aenderungen.
          Du kannst die JSON-Datei auch in einem Cloud-Speicher (z.B. Google Drive, Dropbox) ablegen.
        </div>
      </div>
    </div>
  );
}

export default BackupManager;
